export function toSnakeCase(input: string): string {
  const camelToSnake = input.replace(/([A-Z])/g, '_$1').toLowerCase();
  const words = camelToSnake.split(/[\s_]+/);
  const filteredWords = words.filter((word) => word !== '');
  const snakeCase = filteredWords.join('_');

  return snakeCase;
}
